/**
 * Drok "face-d" mark in the avatar's 100-unit space: a D whose bowl is a rounded
 * screen-head. Derived from the 1024 glyph (scale 0.1, offset -1.2/-7.2).
 * The body is drawn in the theme's foreground ink; the eyes keep LOGO_EYE_COLOR.
 */
export const LOGO_BODY_PATH = "M24 12H50A32 32 0 0 1 50 76H24A6 6 0 0 1 18 70V18A6 6 0 0 1 24 12Z";

/** Brand blue for the two vertical-pill eyes. */
export const LOGO_EYE_COLOR = "#1884FC";

/** Vertical pill eyes: centres, shared vertical centre and half-extents. */
export const LOGO_EYES = {
  centers: [44.3, 59.3],
  cy: 44,
  rx: 4.2,
  ry: 8.5,
} as const;
